import { render, staticRenderFns } from "./DriversListView.vue?vue&type=template&id=3f20456c"
import script from "./DriversListView.vue?vue&type=script&lang=js"
export * from "./DriversListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports